import { render, staticRenderFns } from "./staff-set.vue?vue&type=template&id=207c097a&scoped=true&"
import script from "./staff-set.vue?vue&type=script&lang=js&"
export * from "./staff-set.vue?vue&type=script&lang=js&"
import style0 from "./staff-set.vue?vue&type=style&index=0&id=207c097a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207c097a",
  null
  
)

export default component.exports